import { render, staticRenderFns } from "./Vincular.vue?vue&type=template&id=508115c7&scoped=true"
import script from "./Vincular.vue?vue&type=script&lang=js"
export * from "./Vincular.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=508115c7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508115c7",
  null
  
)

export default component.exports